import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-template',
  templateUrl: './image-template.component.html',
  styleUrls: ['./image-template.component.scss']
})
export class ImageTemplateComponent implements OnInit {
  imageArray:any=[];
  showspinner:boolean=false;
  constructor(public dialogRef: MatDialogRef<ImageTemplateComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,) {
    dialogRef.disableClose = true;
   }

  ngOnInit(): void {
    console.log(this.data.imagetemplateArray);
    if(this.data.imagetemplateArray.lenght >0){
      this.imageArray= this.data.imagetemplateArray;
    }else{
      this.imageArray=[];
    }
   
    // this.imageArray.push({
    //   img:'assets/img/EyeImages/ac 2.bmp'
    // },{
    //   img:'assets/img/EyeImages/Adn Rt.JPG'
    // },{
    //   img:'assets/img/EyeImages/AdnLt.JPG'
    // },{
    //   img:'assets/img/EyeImages/CDR.JPG'
    // },{
    //   img:'assets/img/EyeImages/cla.bmp'
    // },{
    //   img:'assets/img/EyeImages/clr.bmp'
    // },{
    //   img:'assets/img/EyeImages/Cornea Lt.JPG'
    // },{
    //   img:'assets/img/EyeImages/Cornea Rt.JPG'
    // },{
    //   img:'assets/img/EyeImages/Cornea.JPG'
    // },{
    //   img:'assets/img/EyeImages/cornea1.jpg'
    // },{
    //   img:'assets/img/EyeImages/Cr Lt.JPG'
    // },{
    //   img:'assets/img/EyeImages/Cr Rt.JPG'
    // },{
    //   img:'assets/img/EyeImages/cra.bmp'
    // },{
    //   img:'assets/img/EyeImages/ERER1.bmp'
    // },{
    //   img:'assets/img/EyeImages/EYEL.bmp'
    // },{
    //   img:'assets/img/EyeImages/eyesection.bmp'
    // },{
    //   img:'assets/img/EyeImages/gle.bmp'
    // },{
    //   img:'assets/img/EyeImages/grid1.bmp'
    // },{
    //   img:'assets/img/EyeImages/IO chart.JPG'
    // },{
    //   img:'assets/img/EyeImages/Iris Pupil.JPG'
    // },{
    //   img:'assets/img/EyeImages/LE.bmp'
    // },{
    //   img:'assets/img/EyeImages/LENS Lt.JPG'
    // },{
    //   img:'assets/img/EyeImages/LENS Rt.JPG'
    // },{
    //   img:'assets/img/EyeImages/lens.bmp'
    // },{
    //   img:'assets/img/EyeImages/Mac Lt.JPG'
    // },{
    //   img:'assets/img/EyeImages/Mac Rt.JPG'
    // },{
    //   img:'assets/img/EyeImages/OCT.bmp'
    // },{
    //   img:'assets/img/EyeImages/OptImage-for-editing.bmp'
    // },{
    //   img:'assets/img/EyeImages/RE.bmp'
    // },{
    //   img:'assets/img/EyeImages/Refl.bmp'
    // },{
    //   img:'assets/img/EyeImages/REFlE.bmp'
    // },{
    //   img:'assets/img/EyeImages/RefR1.bmp'
    // },{
    //   img:'assets/img/EyeImages/REFRE.bmp'
    // },{
    //   img:'assets/img/EyeImages/RETINAL1.bmp'
    // },{
    //   img:'assets/img/EyeImages/RETINAL2.bmp'
    // },{
    //   img:'assets/img/EyeImages/Sclera 2.JPG'
    // },{
    //   img:'assets/img/EyeImages/Sclera.JPG'
    // })
  }
  closepopup() {
    this.dialogRef.close(0);
  }
  getImage(image:any){
    this.showspinner=true;
    this.getBase64ImageFromUrl(`https://cors-fix.web.app/v1?url=${image.imageName}`)
    .then((result:any) =>{
      let newdata={
        "arrayobj":image,
        "blob64":result
      }
      this.dialogRef.close(newdata);
      this.showspinner=false;
    })  
    .catch(err => {
      this.showspinner=false;
    });
   
  }
  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();
  
    return new Promise((resolve, reject) => {
      var reader  = new FileReader();
      reader.addEventListener("load", function () {
          resolve(reader.result);
      }, false);
  
      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }
}
